<template>
  <div
    id="teams"
    class="flex items-center justify-center px-40 py-16 bg-white align-center"
  >
    <div class="flex items-center justify-center w-1/2 align-center">
      <img
        src="../../../assets/about.jpg"
        alt="About image"
        srcset=""
        class=""
      />
    </div>
    <div class="flex flex-col items-start w-1/2 align-start">
      <div class="flex items-center justify-start align-start">
        <div class="w-48 h-1 rounded-sm bg-[#696969]"></div>
        <h1 class="px-8 py-8 text-xl font-bold text-[#696969]">
          <span class="primary">Equipe</span> Smart Coders Pro
        </h1>
      </div>
      <h1 class="py-1 text-4xl font-bold text-black">
        Bienvenue à la meilleure
      </h1>
      <h1 class="py-1 text-4xl font-bold primary">Agence Digitale</h1>
      <p class="py-3 text-base text-[#696969] text-justify">
        Smart Coders Pro est une agence digitale dynamique spécialisée dans la
        conception et le développement de contenus et d'applications digitales
        sur mesure. Forte d'une équipe d'experts créatifs et technologiques,
        l'agence propose des solutions innovantes qui répondent aux besoins
        spécifiques de ses clients, qu'il s'agisse de sites web, d'applications
        mobiles ou de stratégies de marketing numérique. Smart Coders Pro met
        l'accent sur l'expérience utilisateur, en intégrant des designs
        attrayants et des fonctionnalités intuitives pour garantir une
        interaction fluide et engageante.
      </p>
      <p class="py-3 text-base text-[#696969] text-justify">
        En collaborant étroitement avec ses clients tout au long du processus de
        développement, l'agence veille à ce que chaque projet reflète
        parfaitement l'identité de marque et les objectifs commerciaux. Grâce à
        une approche axée sur la performance et l'optimisation, Smart Coders Pro
        aide les entreprises à renforcer leur présence en ligne et à atteindre
        une audience plus large.
      </p>
      <button
        type="button"
        class="px-10 py-3 my-3 font-medium text-center text-white rounded-lg bg-primary focus:ring-4 focus:outline-none text-md"
      >
        Contactez nous
      </button>
    </div>
  </div>
</template>
